import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ICommissionPayout } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, ICommissionPayout> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
